import Component from '../inherited/Component'

export default class KeenSliderNav extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._mainSlider = this._theme.getComponent(this._options.parentSlider)
  }

  mount () {

    let activeSlide = this._mainSlider.component._slider.track.details.abs
    this._elem.querySelectorAll('.keen-slider__nav-item')[activeSlide].classList.add('is-active')

    for (let [index, item] of this._elem.querySelectorAll('.keen-slider__nav-item').entries()) {
      item.addEventListener('mouseenter', e => {
        this._elem.querySelectorAll('.keen-slider__nav-item').forEach((element) => {
          (element == item) ? element.classList.add('is-active') : element.classList.remove('is-active')
        });
        this.goToSlide(index)
      })

      item.addEventListener('click', e => {
        this._elem.querySelectorAll('.keen-slider__nav-item').forEach((element) => {
          (element == item) ? element.classList.add('is-active') : element.classList.remove('is-active')
        });
        this.goToSlide(index)
      })
    }

    this._ctx.on('keen-slider:change', payload => {
      for (let [index, item] of this._elem.querySelectorAll('.keen-slider__nav-item').entries()) {
        if (Number(item.dataset.dot) === payload.activeSlide) {
          item.classList.add('is-active')
          this.goToSlide(index)
        } else {
          item.classList.remove('is-active')
        }
      }
    })
  }

  goToSlide(index) {
    this._mainSlider.component.goToSlide(index)
  }
}